import AxiosConfiguration from '@/classes/AxiosConfiguration';
import { ConfigurationChangeModel } from '@/types';
import axios from 'axios';

export const ConfigurationChangeService = {
  async beginChangeAsync(controllerPath: string, change: ConfigurationChangeModel): Promise<ConfigurationChangeModel> {
    const response = await axios.post(`${controllerPath}/change`, change);
    return response.data;
  },
  async endChangeAsync(controllerPath: string, changeId: number): Promise<ConfigurationChangeModel> {
    const response = await axios.put(`${controllerPath}/change/${changeId}`);
    return response.data;
  },
  async getChangeWithErrorPageAsync(controllerPath: string): Promise<ConfigurationChangeModel> {
    const response = await AxiosConfiguration.axiosWithErrorPage.get(`${controllerPath}/change`);
    return response.data;
  },
};